<a
  *ngIf="refundRequest$ | async as refundRequest; else noProductType"
  class="button-ghost"
  [routerLink]="['../extensions/refund']"
  [queryParams]="refundParam(refundRequest?.id)"
  ><span> {{ refundRequest?.status }}</span></a
>
<ng-template #noProductType>
  <div>*</div>
</ng-template>
